// src/api/auth.js
import axios from 'axios';


const BASE_URL = 'https://portfolio-backend-1-nmwf.onrender.com'

export const getAccessToken = async () => {
  const refresh = localStorage.getItem('refresh');

  if (!refresh) {
    console.error('No refresh token found');
    return null;
  }

  try {
    const res = await axios.post(`${BASE_URL}/token/refresh/`, { refresh });
    localStorage.setItem('access', res.data.access);
    return res.data.access;
  } catch (err) {
    console.error('Error refreshing token:', err);
    return null;
  }
};

export const initTokens = async () => {
  // Do this only once, manually
  localStorage.setItem('access', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzQ1MjkwNTU1LCJpYXQiOjE3NDUyODY5NTUsImp0aSI6ImI2NGRiY2M2NTI3OTQwYWI4Y2E0NmFjOTQ4ZGRlMGRiIiwidXNlcl9pZCI6MX0.XRmCU83I-wl3_3tUfOcztXbHnR971hXVNo-rsIwIECQ');
  localStorage.setItem('refresh', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImV4cCI6MTc0NTg5MTc1NSwiaWF0IjoxNzQ1Mjg2OTU1LCJqdGkiOiJiMzA4ZWE2ZGY2ZTg0MTBiOGM1ZDViMzZmNGJiY2FjMCIsInVzZXJfaWQiOjF9.4HvzfpuMmWh-RdvBh1br0b8kUQfvjaTgJhwdT2nTO_o');
};
